import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Linkedin } from 'lucide-react';

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <div className="container">
        <button onClick={() => navigate('/')} className="back-btn">
          <ArrowLeft size={20} />
          Voltar à página inicial
        </button>
        
        <div className="about-hero">
          <h1>Sobre a Nacodara</h1>
          <p>Transformando o futuro da programação em Moçambique através da educação digital</p>
        </div>
        
        <div className="about-content">
          <div className="company-overview">
            <h2>Quem Somos</h2>
            <p>
              A Nacodara é uma plataforma moçambicana de aprendizagem digital que capacita jovens 
              de todo o país a desenvolver habilidades em programação e tecnologia. Oferecemos 
              cursos acessíveis, simples de entender e conectados à realidade do nosso mercado.
            </p>
          </div>

          <div className="leadership-section">
            <h2>Liderança</h2>
            <div className="ceo-card">
              <div className="ceo-image">
                <div className="avatar-placeholder rounded-full overflow-hidden">
                  <img src="/ceo.png" alt="" srcset="" />
                </div>
              </div>
              <div className="ceo-info">
                <h3>Joaquim Magode</h3>
                <p className="ceo-title">CEO & Fundador</p>
                <p className="ceo-description">
                  Visionário em tecnologia educacional com paixão por capacitar a próxima geração 
                  de programadores moçambicanos. Joaquim fundou a Nacodara com a missão de 
                  democratizar o acesso ao conhecimento em programação.
                </p>
                <a href="https://linkedin.com/in/joaquimmagode" target="_blank" rel="noopener noreferrer" className="linkedin-btn">
                  <Linkedin size={20} />
                  LinkedIn
                </a>
              </div>
            </div>
          </div>
          
          <div className="mission-vision">
            <div className="mission-card">
              <h3>Nossa Missão</h3>
              <p>
                Capacitar jovens moçambicanos com habilidades de programação de classe mundial, 
                criando oportunidades de carreira e impulsionando a inovação tecnológica no país.
              </p>
            </div>
            <div className="vision-card">
              <h3>Nossa Visão</h3>
              <p>
                Ser a principal plataforma de educação em tecnologia em Moçambique, 
                formando a próxima geração de líderes tecnológicos africanos.
              </p>
            </div>
          </div>
          
          <div className="values-section">
            <h2>Nossos Valores</h2>
            <div className="values-grid">
              <div className="value-card">
                <h3>Excelência</h3>
                <p>Comprometidos com a mais alta qualidade em educação tecnológica</p>
              </div>
              <div className="value-card">
                <h3>Acessibilidade</h3>
                <p>Tornando a educação em programação acessível a todos os moçambicanos</p>
              </div>
              <div className="value-card">
                <h3>Inovação</h3>
                <p>Sempre na vanguarda das tecnologias e metodologias educacionais</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;